import {useCallback, FC} from 'react';
import {usePlayerContext} from '../../hooks/usePlayerContext';
import {useIsMuted, useVolume} from '../../hooks/usePlayerState';
import {Bar} from '../bar';

const barWidth = 100;

export const VolumeBar: FC = () => {
  const {accentColor, player} = usePlayerContext();
  const isMuted = useIsMuted();
  const volume = useVolume();

  const handleVolumeChange = useCallback(
    (value: number): void => {
      if (!player) return;

      if (player.isMuted() && value > 0) {
        player.unmute();
      }

      if (value <= 0) {
        player.mute();
      }

      player.setVolume(value);
    },
    [player]
  );

  return (
    <div style={{width: barWidth}}>
      <Bar
        onChange={handleVolumeChange}
        minValue={0}
        maxValue={100}
        value={isMuted ? 0 : volume}
        width={barWidth}
        color={accentColor}
      />
    </div>
  );
};
